"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLANS = void 0;
const PLANS = exports.PLANS = {
  "student": {
    "name": "Student",
    "month": {
      "pricePerMonth": "$8",
      "pricePerBillingPeriod": "$8"
    },
    "year": {
      "pricePerMonth": "$6",
      "pricePerBillingPeriod": "$72"
    }
  },
  "practitioner": {
    "name": "Practitioner",
    "month": {
      "pricePerMonth": "$12",
      "pricePerBillingPeriod": "$12"
    },
    "year": {
      "pricePerMonth": "$9",
      "pricePerBillingPeriod": "$108"
    }
  },
  "researcher": {
    "name": "Researcher",
    "month": {
      "pricePerMonth": "$16",
      "pricePerBillingPeriod": "$16"
    },
    "year": {
      "pricePerMonth": "$12",
      "pricePerBillingPeriod": "$144"
    }
  }
};